import { PatientPageNumber } from '../../components/Paperwork/providerGroups/components/Patient/constants';
import { MedicalPageNumber } from '../../components/Paperwork/providerGroups/components/Medical/constants';
import { VerificationAndReviewPageNumber } from '~/components/Paperwork/providerGroups/components/VerificationAndReview/constants';
import { LifestyleFactorsPageNumber } from '~/components/Paperwork/providerGroups/components/LifestyleFactors/constants';
import { HealthcareContactsPageNumber } from '~/components/Paperwork/providerGroups/components/HealthcareContacts/constants';
import { PGSectionNumber } from '~/components/Paperwork/providerGroups/constants';

export default {
  common: {
    required: '{{FORM_FIELD_NAME}} is required',
    requiredShort: 'Required',
    optional: 'Optional',
    sectionSubtitle: 'Section {{CURRENT_SECTION}} of {{TOTAL_SECTIONS}}',
  },
  [PGSectionNumber.Patient]: {
    sectionTitle: 'Patient information',
    pages: {
      [PatientPageNumber.BasicInfo]: {
        genericTitle: 'Who is the appointment for?',
        personalTitle: 'Who is the appointment for?',
        subtitle:
          'Please use legal name to help the office keep track of your medical records more easily.',
      },
      [PatientPageNumber.Address]: {
        genericTitle: 'What is your primary address?',
        personalTitle: "What is {{name}}'s primary address?",
        subtitle: '',
      },
      [PatientPageNumber.Guardian]: {
        genericTitle: '',
        personalTitle: "Who is {{name}}'s legal guardian?",
        subtitle: '',
      },
      [PatientPageNumber.Language]: {
        genericTitle: 'What is your primary language?',
        personalTitle: "What is {{name}}'s primary language?",
        subtitle: "We'll let the office know ahead of your appointment",
      },
      [PatientPageNumber.LanguageOther]: {
        genericTitle: 'What is your primary language?',
        personalTitle: "What is {{name}}'s primary language?",
        subtitle: "We'll let the office know ahead of your appointment",
      },
      [PatientPageNumber.Gender]: {
        genericTitle: 'What is your gender identity?',
        personalTitle: "What is {{name}}'s gender identity?",
        subtitle: '',
      },
      [PatientPageNumber.Pronouns]: {
        genericTitle: 'What are your gender pronouns?',
        personalTitle: "What are {{name}}'s gender pronouns?",
        subtitle: 'This helps the office know how to refer to you',
      },
      [PatientPageNumber.Race]: {
        genericTitle: 'What is your race?',
        personalTitle: "What is {{name}}'s race?",
        subtitle: '',
      },
      [PatientPageNumber.Ethnicity]: {
        genericTitle: 'What is your ethnicity?',
        personalTitle: "What is {{name}}'s ethnicity?",
        subtitle: 'This helps your provider get a more accurate picture of your healthcare needs',
      },
    },
  },
  [PGSectionNumber.Medical]: {
    sectionTitle: 'Medical information',
    pages: {
      [MedicalPageNumber.Symptoms]: {
        genericTitle: 'Are you currently experiencing any of these symptoms?',
        personalTitle: 'Is {{name}} currently experiencing any of these symptoms?',
        subtitle: 'Please select all that apply.',
      },
      [MedicalPageNumber.PastConditions]: {
        genericTitle: 'Have you ever had any of these medical conditions?',
        personalTitle: 'Has {{name}} ever had any of these medical conditions?',
        subtitle: 'Please select all that apply.',
      },
      [MedicalPageNumber.Procedures]: {
        genericTitle: 'Have you had any of the following surgeries or procedures?',
        personalTitle: 'Has {{name}} ever had any of the following surgeries or procedures?',
        subtitle: '',
      },
      [MedicalPageNumber.MedicationsIsTaking]: {
        genericTitle: 'Are you taking any medications?',
        personalTitle: 'Is {{name}} taking any medications?',
        subtitle: '',
      },
      [MedicalPageNumber.MedicationsList]: {
        genericTitle: 'What medications are you taking?',
        personalTitle: 'What medications is {{name}} taking?',
        subtitle: '',
      },
      [MedicalPageNumber.Allergies]: {
        genericTitle: 'Do you have any known allergies?',
        personalTitle: 'Does {{name}} have any known allergies?',
        subtitle: '',
      },
      [MedicalPageNumber.AllergiesList]: {
        genericTitle: 'What are you allergic to?',
        personalTitle: 'What is {{name}} allergic to?',
        subtitle: '',
      },
      [MedicalPageNumber.ImmunizationStatus]: {
        genericTitle: 'Are your immunizations up to date?',
        personalTitle: "Is {{name}}'s immunizations up to date?",
        subtitle: '',
      },
      [MedicalPageNumber.Pregnancy]: {
        genericTitle: 'Have you ever been pregnant?',
        personalTitle: 'Has {{name}} ever been pregnant?',
        subtitle: '',
      },
      [MedicalPageNumber.BirthControl]: {
        genericTitle: 'Do you use any forms of birth control?',
        personalTitle: 'Does {{name}} use any forms of birth control?',
        subtitle: '',
      },
      [MedicalPageNumber.PapSmear]: {
        genericTitle: 'Have you ever had a pap smear?',
        personalTitle: 'Has {{name}} ever had a pap smear?',
        subtitle: '',
      },
      [MedicalPageNumber.PapSmearDate]: {
        genericTitle: 'When was your last pap smear?',
        personalTitle: "When was {{name}}'s last pap smear?",
        subtitle: 'Please provide your best estimate.',
      },
      [MedicalPageNumber.Menopause]: {
        genericTitle: 'When was your last period?',
        personalTitle: "When was {{name}}'s last period?",
        subtitle: '',
      },
      [MedicalPageNumber.Mammogram]: {
        genericTitle: 'Have you ever had a mammogram?',
        personalTitle: 'Has {{name}} ever had a mammogram?',
        subtitle: '',
      },
      [MedicalPageNumber.FamilyHistory]: {
        genericTitle: 'Has anyone in your family had any of the following medical conditions?',
        personalTitle:
          "Has anyone in {{name}}'s family had any of the following medical conditions?",
        subtitle:
          'Please select all that apply for any blood relative including parents, siblings, children, grandparents, uncles, and aunts.',
      },
    },
  },
  [PGSectionNumber.LifestyleFactors]: {
    sectionTitle: 'Lifestyle factors',
    pages: {
      [LifestyleFactorsPageNumber.MaritalStatus]: {
        genericTitle: 'What is your marital status?',
        personalTitle: "What is {{name}}'s marital status?",
        subtitle: '',
      },
      [LifestyleFactorsPageNumber.Alcohol]: {
        genericTitle: 'Do you drink alcohol?',
        personalTitle: 'Does {{name}} drink alcohol?',
        subtitle: '',
      },
      [LifestyleFactorsPageNumber.AlcoholIntake]: {
        genericTitle: 'How much do you typically drink per week?',
        personalTitle: 'How much does {{name}} typically drink per week?',
        subtitle: '',
      },
      [LifestyleFactorsPageNumber.EverSmoked]: {
        genericTitle: 'Have you ever smoked or used tobacco products regularly?',
        personalTitle: 'Has {{name}} ever smoked or used tobacco products regularly?',
        subtitle: '',
      },
      [LifestyleFactorsPageNumber.CurrentSmoker]: {
        genericTitle: 'Do you currently smoke or use tobacco products?',
        personalTitle: 'Does {{name}} currently smoke or use tobacco products?',
        subtitle: '',
      },
      [LifestyleFactorsPageNumber.SmokingIntake]: {
        genericTitle: 'Typical tobacco use',
        personalTitle: 'Typical tobacco use',
        subtitle: '',
      },
      [LifestyleFactorsPageNumber.SmokingLength]: {
        genericTitle: 'Number of years using tobacco products',
        personalTitle: 'Number of years using tobacco products',
        subtitle: '',
      },
      [LifestyleFactorsPageNumber.Drugs]: {
        genericTitle: 'Do you use recreational drugs?',
        personalTitle: 'Does {{name}} use recreational drugs?',
        subtitle: 'This helps your provider get a more accurate picture of your healthcare needs.',
      },
      [LifestyleFactorsPageNumber.DrugsList]: {
        genericTitle: 'What kind of drugs?',
        personalTitle: 'What kind of drugs?',
        subtitle: 'This helps your provider get a more accurate picture of your healthcare needs.',
      },
      [LifestyleFactorsPageNumber.SexuallyActive]: {
        genericTitle: 'Are you sexually active?',
        personalTitle: 'Is {{name}} sexually active?',
        subtitle: 'This helps your provider get a more accurate picture of your healthcare needs.',
      },
    },
  },
  [PGSectionNumber.HealthcareContacts]: {
    sectionTitle: 'Healthcare contacts',
    pages: {
      [HealthcareContactsPageNumber.Pharmacy]: {
        genericTitle: 'Which pharmacy do you use?',
        personalTitle: 'Which pharmacy does {{name}} use?',
        subtitle: '',
      },
      [HealthcareContactsPageNumber.HasPrimaryCareProvider]: {
        genericTitle: 'Do you have a primary care provider?',
        personalTitle: 'Does {{name}} have a primary care provider?',
        subtitle: '',
      },
      [HealthcareContactsPageNumber.PrimaryCareProvider]: {
        genericTitle: 'Who is your primary care provider?',
        personalTitle: "Who is {{name}}'s primary care provider?",
        subtitle: '',
      },
      [HealthcareContactsPageNumber.EmergencyContact]: {
        genericTitle: 'Who is your emergency contact?',
        personalTitle: "Who is {{name}}'s emergency contact?",
        subtitle: '',
      },
      [HealthcareContactsPageNumber.IsEmployed]: {
        genericTitle: 'Are you employed?',
        personalTitle: 'Is {{name}} employed?',
        subtitle: '',
      },
      [HealthcareContactsPageNumber.IsEmployerRequest]: {
        genericTitle: 'Is this appointment due to an injury or incident that occurred at work?',
        personalTitle: 'Is this appointment due to an injury or incident that occurred at work?',
        subtitle: '',
      },
      [HealthcareContactsPageNumber.EmployerInfo]: {
        genericTitle: 'Where are you employed?',
        personalTitle: 'Where is {{name}} employed?',
        subtitle: '',
      },
    },
  },
  [PGSectionNumber.VerificationAndReview]: {
    sectionTitle: 'Verification & review',
    pages: {
      [VerificationAndReviewPageNumber.Ssn]: {
        genericTitle: 'What is your Social Security number?',
        personalTitle: "What is {{name}}'s Social Security number?",
        subtitle:
          'This helps the office verify your identity and insurance information. We use best-in-class security practices to keep your data secure.',
      },
      [VerificationAndReviewPageNumber.ProviderNotes]: {
        genericTitle: 'Anything else that {{provider_name}} should know?',
        personalTitle: 'Anything else that {{provider_name}} should know?',
        subtitle: '',
      },
    },
  },
  standardFields: {
    patientFirstName: {
      default: 'First name',
      error: 'First name',
      finalize: 'First name',
    },
    patientMiddleName: {
      default: 'Middle name',
      error: 'Middle name',
      finalize: 'Middle name',
    },
    patientLastName: {
      default: 'Last name',
      error: 'Last name',
      finalize: 'Last name',
    },
    patientBirthSex: {
      default: 'Sex assigned at birth',
      error: 'Sex assigned at birth',
      finalize: 'Sex assigned at birth',
    },
    birthDate: {
      default: 'Date of birth',
      error: 'Date of birth',
      finalize: 'Date of birth',
    },
    primaryPhone: {
      default: 'Phone',
      error: 'Phone',
      finalize: 'Phone',
    },
    email: {
      default: 'Email',
      error: 'Email',
      finalize: 'Email',
    },
    patientAddressStreet: {
      default: 'Street address',
      error: 'Street address',
      finalize: 'Street address',
    },
    patientAddressStreetTwo: {
      default: 'Street address line 2',
      error: 'Street address line 2',
      finalize: 'Street address line 2',
      helperText: 'Apt#, bld#, suite, etc',
    },
    patientAddressCity: {
      default: 'City',
      error: 'City',
      finalize: 'City',
    },
    patientAddressState: {
      default: 'State',
      error: 'State',
      finalize: 'State',
    },
    patientAddressZip: {
      default: 'Zipcode',
      error: 'Zipcode',
      finalize: 'Zipcode',
    },
    guardianFirstName: {
      default: 'First name',
      error: 'First name',
      finalize: 'Guardian first name',
    },
    guardianLastName: {
      default: 'Last name',
      error: 'Last name',
      finalize: 'Guardian last name',
    },
    guardianBirthDate: {
      default: 'Date of birth',
      error: 'Date of birth',
      finalize: 'Guardian date of birth',
    },
    guardianPhone: {
      default: 'Phone',
      error: 'Phone',
      finalize: 'Guardian phone',
    },
    guardianAddress: {
      default: 'Street address',
      error: 'Street address',
      finalize: 'Guardian street address',
    },
    'pg_guardian_address-two': {
      default: 'Street address line 2',
      error: 'Street address line 2',
      finalize: 'Guardian street address line 2',
      helperText: 'Apt#, bld#, suite, etc',
    },
    pg_guardian_city: {
      default: 'City',
      error: 'City',
      finalize: 'Guardian city',
    },
    pg_guardian_state: {
      default: 'State',
      error: 'State',
      finalize: 'Guardian state',
    },
    pg_guardian_zip: {
      default: 'Zipcode',
      error: 'Zipcode',
      finalize: 'Guardian zipcode',
    },
    'pg_language_primary-language': {
      default: 'Primary language',
      error: 'Primary language',
      finalize: 'Primary language',
    },
    pg_language_other: {
      default: '',
      error: 'Language - other',
      finalize: 'Language - other',
    },
    patientGender: {
      default: 'Gender',
      error: 'Gender',
      finalize: 'Gender',
    },
    'pg_pronouns_preferred-pronouns': {
      default: 'Pronouns',
      error: 'Pronouns',
      finalize: 'Pronouns',
    },
    race: {
      default: 'Race',
      error: 'Race',
      finalize: 'Race',
    },
    ethnicity: {
      default: 'Ethnicity',
      error: 'Ethnicity',
      finalize: 'Ethnicity',
    },
    'pg_review-of-systems_symptoms': {
      default: 'Current symptoms',
      error: 'Current symptoms',
      finalize: 'Current symptoms',
    },
    'pg_past-conditions_medical-conditions': {
      default: 'Past medical history',
      error: 'Past medical history',
      finalize: 'Past medical history',
    },
    pg_procedures_surgeries: {
      default: 'Past procedures',
      error: 'Past procedures',
      finalize: 'Past procedures',
    },
    'pg_medications_is-taking': {
      default: 'Taking medications',
      error: 'Taking medications',
      finalize: 'Taking medications',
    },
    pg_medications_list: {
      default: 'Medication',
      error: 'Medication',
      finalize: 'Medication',
    },
    'pg_allergies_any-known': {
      default: 'Known allergies',
      error: 'Known allergies',
      finalize: 'Known allergies',
    },
    pg_allergies_list: {
      default: 'Allergy',
      error: 'Allergy',
      finalize: 'Allergy',
    },
    'pg_immunization_status-is-up-to-date': {
      default: 'Immunizations',
      error: 'Immunizations',
      finalize: 'Immunizations',
    },
    'pg_obgyn_pregnancy-ever-been-pregnant': {
      default: 'Past pregnancies',
      error: 'Past pregnancies',
      finalize: 'Past pregnancies',
    },
    'pg_obgyn_birth-control-use': {
      default: 'Using birth control',
      error: 'Using birth control',
      finalize: 'Using birth control',
    },
    'pg_obgyn_pap-smear-ever-had': {
      default: 'Ever had pap smear',
      error: 'Ever had pap smear',
      finalize: 'Ever had pap smear',
    },
    'pg_obgyn_pap-smear-last-date': {
      default: 'Date',
      error: 'Last pap smear',
      finalize: 'Last pap smear',
    },
    'pg_obgyn_menopause-last-period': {
      default: 'Last date of last period',
      error: 'Last period',
      finalize: 'Last period',
    },
    'pg_obgyn_mammogram-ever-had': {
      default: 'Ever had mammogram',
      error: 'Ever had mammogram',
      finalize: 'Ever had mammogram',
    },
    'pg_family-history_medical-conditions': {
      default: 'Conditions',
      error: 'Conditions',
      finalize: 'Conditions',
    },
    maritalStatus: {
      default: 'Marital status',
      error: 'Marital status',
      finalize: 'Marital status',
    },
    'pg_alcohol_do-you-drink': {
      default: 'Drinks alcohol',
      error: 'Drinks alcohol',
      finalize: 'Drinks alcohol',
    },
    'pg_alcohol_how-much': {
      default: 'Number of drinks',
      error: 'Alcohol intake',
      finalize: 'Alcohol intake',
    },
    'pg_smoking_has-ever-smoked': {
      default: 'Ever used tobacco products',
      error: 'Ever used tobacco products',
      finalize: 'Ever used tobacco products',
    },
    'pg_smoking_past-usage': {
      default: 'Current or past smoker',
      error: 'Current or past smoker',
      finalize: 'Current or past smoker',
    },
    pg_smoking_amount: {
      default: 'Tobacco intake',
      error: 'Tobacco intake',
      finalize: 'Tobacco intake',
    },
    'pg_smoking_how-long': {
      default: '',
      error: 'Smoking duration',
      finalize: 'Years using tobacco products',
    },
    'pg_drugs_recreational-drugs': {
      default: 'Recreational drugs',
      error: 'Recreational drugs',
      finalize: 'Recreational drugs',
    },
    pg_drugs_list: {
      default: 'Substances',
      error: 'Substances',
      finalize: 'Substances',
    },
    'pg_sexual-activity_active': {
      default: 'Sexually active',
      error: 'Sexually active',
      finalize: 'Sexually active',
    },
    pharmacy: {
      default: '',
      error: 'Pharmacy',
      finalize: 'Pharmacy',
    },
    'pg_pcp_has-pcp': {
      default: '',
      error: 'Has primary care provider',
      finalize: 'Has primary care provider',
    },
    physician: {
      default: '',
      error: 'Primary care provider',
      finalize: 'Primary care provider',
    },
    emergencyContactFirstName: {
      default: 'First name',
      error: 'First name',
      finalize: 'Emergency contact first name',
    },
    emergencyContactLastName: {
      default: 'Last name',
      error: 'Last name',
      finalize: 'Emergency contact last name',
    },
    emergencyContactPhone: {
      default: 'Phone number',
      error: 'Phone number',
      finalize: 'Emergency contact phone',
    },
    'pg_emergency-contact_email': {
      default: 'Email',
      error: 'Email',
      finalize: 'Emergency contact email',
    },
    emergencyContactRelationshipToPatient: {
      default: 'Relationship to patient',
      error: 'Relationship to patient',
      finalize: 'Emergency contact relationship to patient',
    },
    'pg_employment_is-employed': {
      default: '',
      error: 'Employed',
      finalize: 'Employed',
    },
    areYouBeingTreatedAtTheRequestOfYourEmployer: {
      default: '',
      error: 'Work injury or incident',
      finalize: 'Work injury or incident',
    },
    employer: {
      default: 'Name of employer',
      error: 'Name of employer',
      finalize: 'Employer name',
    },
    'pg_employment_job-title': {
      default: 'Role or job title',
      error: 'Role or job title',
      finalize: 'Role or job title',
    },
    workInjuryEmployerContactPhoneNumber: {
      default: 'Phone',
      error: 'Phone',
      finalize: 'Employer phone',
    },
    ssn: {
      default: 'Social Security number',
      error: 'Social Security number',
      finalize: 'Social Security number',
    },
    reasonForVisit: {
      default: 'Notes for the provider',
      error: 'Notes for the provider',
      finalize: 'Notes for provider',
    },
    legalTreatment: {
      default: 'Legal {{field}}',
      error: 'Legal {{field}}',
      finalize: 'Legal {{field}}',
    },
  },
};
